import React, { ReactNode } from "react";
import { AppNavbar } from "./appNavbar";
import { AppSpinner } from "./appSpinner";
import Container from "react-bootstrap/Container";

type Props = {
    children: ReactNode;
    loading?: boolean;
}

export const AppLayout = ({ children, loading }: Props) => {
    return (
        <>
            <AppNavbar/>
            <main className="app-main">
                {loading ?
                    <Container fluid>
                        <AppSpinner/>
                    </Container>
                    : children
                }
            </main>
        </>
    );
}